import {
  GET_EVALUATIONS,
  GET_EVALUATIONS_FAIL,
  GET_EVALUATIONS_SUCCESS,
  ADD_NEW_EVALUATION,
  ADD_EVALUATION_SUCCESS,
  ADD_EVALUATION_FAIL,
  UPDATE_EVALUATION,
  UPDATE_EVALUATION_SUCCESS,
  UPDATE_EVALUATION_FAIL,
  DELETE_EVALUATION,
  DELETE_EVALUATION_SUCCESS,
  DELETE_EVALUATION_FAIL,

  // AVERAGE
  GET_AVERAGE_BY_EVALUATION,
  GET_AVERAGE_BY_EVALUATION_SUCCESS,
  GET_AVERAGE_BY_EVALUATION_FAIL,
  
} from "./actionTypes";

export const getEvaluations = (filters) => ({
  type: GET_EVALUATIONS,
  payload: filters,
})

export const getEvaluationsSuccess = evaluations => ({
  type: GET_EVALUATIONS_SUCCESS,
  payload: evaluations,
})

export const getEvaluationsFail = error => ({
  type: GET_EVALUATIONS_FAIL,
  payload: error,
})

export const addNewEvaluation = data => ({
  type: ADD_NEW_EVALUATION,
  payload: data,
})

export const addEvaluationSuccess = evaluation => ({
  type: ADD_EVALUATION_SUCCESS,
  payload: evaluation,
})

export const addEvaluationFail = error => ({
  type: ADD_EVALUATION_FAIL,
  payload: error,
})

export const updateEvaluation = evaluation => ({
  type: UPDATE_EVALUATION,
  payload: evaluation,
})

export const updateEvaluationSuccess = evaluation => ({
  type: UPDATE_EVALUATION_SUCCESS,
  payload: evaluation,
})

export const updateEvaluationFail = error => ({
  type: UPDATE_EVALUATION_FAIL,
  payload: error,
})

export const deleteEvaluation = data => ({
  type: DELETE_EVALUATION,
  payload: data,
})

export const deleteEvaluationSuccess = data => ({
  type: DELETE_EVALUATION_SUCCESS,
  payload: data,
})

export const deleteEvaluationFail = error => ({
  type: DELETE_EVALUATION_FAIL,
  payload: error,
})

export const resetEvaluationLastActionSuccess = () => ({
    type: "RESET_LAST_ACTION_SUCCESS"
});

// AVERAGE
export const getAverageByEvaluation = evaluationUuid => ({
  type: GET_AVERAGE_BY_EVALUATION,
  payload: evaluationUuid,
});

export const getAverageByEvaluationSuccess = averageData => ({
  type: GET_AVERAGE_BY_EVALUATION_SUCCESS,
  payload: averageData,
});

export const getAverageByEvaluationFail = error => ({
  type: GET_AVERAGE_BY_EVALUATION_FAIL,
  payload: error,
});

